export const SET = 'companies/SET';
